import React, { useState, useEffect } from "react";
import AddUser from "./AddUser";
import {
  Box,
  Container,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Button,
  Checkbox,
  Typography,
  Tooltip,
  MenuItem,
  Menu,
  TableSortLabel,
  IconButton,
  Dialog,
  DialogTitle,Divider
} from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";
import { USER_DETAILS_LISTING_COLUMNS } from "../../utils/constant";
import RecordNotFound from "../../common/RecordNotFound";
import SearchIcon from "@mui/icons-material/Search";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { ADD_USER_VALIDATIONS } from "../../utils/Validation";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import Add from "@mui/icons-material/Add";
import UserEditRolesAccessPage from "./UserEditRolesAccessPage";
import ClearIcon from "@mui/icons-material/Clear";
import { visuallyHidden } from "@mui/utils";
import {
  UserChangeStatusService,
  UserRoleAccessInsideUsersPageService,
  onAddUserService,
  onEditUserService,
  UnlockUserService,
} from "../../services/UserOnboardingService";
import useGlobalState from "../../Context";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";

export default function UserList({
  handleTableChanges,
  fetchUsersDetails,
  totalElements,
  BASE_URL,
  userRecords,
  onSearchUser,
  fetchDepartmentList,
  fetchRoleList,
  fetchUserTypeList,
  departmentList,
  roleList,
  userTypeList,
  setLoading,
  showNotification,
  setUserRecords,
  downloadUsersTemplate,
  noRecord,
}) {
  const [nameSearch, setNameSearch] = useState("");
  const [openAddUserDialog, setOpenAddUserDialog] = useState(false);
  const [openEditUserRightsDialog, setOpenEditUserRightsDialog] =
    useState(false);
  const [page, setPage] = useState(0);
  const [maxPage, setMaxPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [searchedRows, setSearchedRows] = useState(userRecords);
  const [isEditMode, setIsEditMode] = useState(false);
  const [formData, setFormData] = useState({});
  const [userId, setUserId] = useState(null);
  const [deptName, setDeptName] = useState("");
  const [roleName, setRoleName] = useState("");
  const [userTypeName, setUserTypeName] = useState("");
  const [selected, setSelected] = useState([]);
  const [disableUpdateButton, setDisbaleUpdateButton] = useState(true);
  const [isUpdateButton, setIsUpdateButton] = useState(true);
  const [userRolesAccessDetails, setUserRolesAccessDetails] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [slcRow, setSlcRow] = useState(null);
  const [roles, setRoles] = useState([]);
  const [sortValue, setSortValue] = useState("ASC");
  const [disableUserType, setDisableUserType] = useState(false);
  const [clearSearch, setClearSearch] = useState(false);
  const [isSearchBtnClick, setIsSearchBtnClick] = useState(false);
  const [searchValue_, setsearchValue_] = useState(null);
  const [{ auth }, ] = useGlobalState();
  const loginUserInfo = auth.ldapParam;
  const [formValues, setFormValues] = useState({
    createdOn: new Date(),
    createdBy: loginUserInfo.userId,
    modifiedBy: loginUserInfo.userId,
  });
  const formOption = {
    //  initialSchema : {
    
    //   isEmail: false, // change this when you want to add validation
      
    // },
    resolver: yupResolver(ADD_USER_VALIDATIONS),
    defaultValues: { ...formData },
  };
  const open = Boolean(anchorEl);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("firstName");
  const [lockUnlockUserDialog, setUserLockUnlockDialog] = useState(false);
  const [userEmail, setUserEmail] = useState();
  const [userName, setUserName] = useState();
  const [isLocked, setIsLocked] = useState();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm(formOption);

  const handleLockUnlockDialogOpen = (email,name,isLockedUser) => {
    setUserEmail(email)
    setUserName(name)
    setIsLocked(isLockedUser)
    setUserLockUnlockDialog(true);
  };
  const handleLockUnlockDialogClose = () => {
    setUserLockUnlockDialog(false);
  };

  // const auth = JSON.parse(localStorage.getItem("auth"));
  // const loggedInUserId = auth.employeeID;
  // console.log("token", loggedInUserId);
  const handleClickOpen = (item) => {
    if (item) {
      reset(item);
    }
    fetchDepartmentList();
    fetchRoleList();
    fetchUserTypeList(item?.userTypeName);
    setOpenAddUserDialog(true);
    setIsEditMode(true);
    setDeptName(item?.deptName);
    setUserTypeName(item?.userTypeName);
    setRoleName(item?.roleName);
    setUserId(item?.userId);
    setFormValues({
      createdOn: item?.createdOn,
      createdBy: item?.createdBy,
      modifiedBy: loginUserInfo.userId,
    });
    setFormData({ ...item });
    if (loginUserInfo.userType === "Domain Admin") {
      if (item?.userTypeName === "Main Admin") {
        setDisableUserType(true);
      } else {
        setDisableUserType(false);
      }
    }
  };

  useEffect(() => {
    const filteredRoles =
      roleList &&
      roleList.filter((r) => r.department['departmentId'] === parseInt(formData.deptId));
    setRoles(filteredRoles);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roleList]);

  const handleClickUserRightsOpen = (item) => {
    setOpenEditUserRightsDialog(true);
    fetchUserRoleAccess(item?.userId);
    setUserId(item?.userId);
  };

  const handleClickOpenOnAdd = () => {
    setFormValues({
      createdOn: new Date(),
      createdBy: loginUserInfo.userId,
      modifiedBy: loginUserInfo.userId,
    });
    setOpenAddUserDialog(true);
    fetchDepartmentList();
    fetchRoleList();
    fetchUserTypeList();
  };

  useEffect(() => {
    reset(formData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openAddUserDialog]);

  const handleClose = () => {
    setOpenAddUserDialog(false);
    setIsEditMode(false);
    setIsUpdateButton(true);
    setFormData({});
    setRoles([]);
  };

  const handleCloseUserRightsDialog = () => {
    setOpenEditUserRightsDialog(false);
  };
  const fetchUserRoleAccess = async (id) => {
    try {
      setLoading(true);
      const response = await UserRoleAccessInsideUsersPageService(id);
      setUserRolesAccessDetails(response.accessPermissionResponseList);
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch user details");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    // const selectedRows =
    //   userRecords &&
    //   userRecords.filter((row) =>
    //     row.firstName.toUpperCase().includes(nameSearch.toUpperCase())
    //   );
    setSearchedRows(userRecords);
    //console.log('userRecords',userRecords)
  }, [nameSearch, userRecords]);

  const onAddEditUserSubmit = async (data) => {
    try {
      let obj = {
        createdBy: formValues.createdBy,
        employeeId: data.employeeId && data.employeeId.trim(),
        mobileNumber: data.mobileNumber && data.mobileNumber.trim(),
        modifiedBy: formValues.createdBy,
        createdOn: formValues.createdOn,
        password: null,
        tempToken: "string",
        active: data.active === "false" ? false : true,
        userTypeId: data.userTypeId,
        roleId: data.roleId,
        deptId: data.deptId,
        deptName,
        email: data.email && data.email.trim(),
        firstName: data.firstName && data.firstName.trim(),
        lastName: data.lastName && data.lastName.trim(),
        roleName,
        userTypeName,
      };
      const checkEmail = data.email?.endsWith("@ril.com");
      const res = isEditMode
      //console.log('obj',obj)
        ? await onEditUserService(BASE_URL, obj, userId, checkEmail)
        : await onAddUserService(BASE_URL, obj, data, checkEmail);
      if (res.statusCode === 6) {
        const newUserRecords = [...userRecords];
        const index = newUserRecords.findIndex((x) => x.userId === userId);
        newUserRecords[index] = { ...userRecords[index], ...obj };
        setUserRecords(newUserRecords);
        handleClose(false);
        setIsUpdateButton(true);
        // if (!isEditMode) {
        //   setPage(0);
        //   setMaxPage(0);

         
        //   await fetchUsersDetails("firstName", true);
        // }
        setSelected([]); setDisbaleUpdateButton(true);
        showNotification("Success", res.message, "success");
        onclickClear()

      } else {
        showNotification("Error", res.message, "error");
      }
    } catch (err) {
      showNotification("Error", err.message, "error");
    }
  };

  const handleChangeRowsPerPage = async (event) => {
    const paginationValues = {
      pageNumber: 0,
      pageSize: +event.target.value,
    };
    await handleTableChanges(paginationValues, false, sortValue, orderBy, searchValue_);
    setPage(0);
    setMaxPage(0);
    setRowsPerPage(+event.target.value);
  };

  const handleChangePage = async (event, newPage) => {
    if (newPage > page && newPage > maxPage) {
      setMaxPage(newPage);
      const paginationValues = {
        pageNumber: newPage,
        pageSize: rowsPerPage,
      };
      await handleTableChanges(paginationValues, true, sortValue, orderBy,searchValue_);
    }
    setPage(newPage);
  };

  const searchText = async (e) => {
    setSearchValue(e.target.value);
    setNameSearch("");
    e.target.value === "" ? setClearSearch(false) : setClearSearch(true);
    if (e.target.value === "") {
      onclickClear();
    }
  };

  const onclickClear = async () => {
    const paginationData = {
      pageNumber: 0,
      pageSize: rowsPerPage ?? 10,
    };
    setsearchValue_(null);
    await fetchUsersDetails("firstName", false,null,paginationData);
    setSelected([]);
    setDisbaleUpdateButton(true)
    setNameSearch("");
    setSearchValue("");
    setPage(0);
    setMaxPage(0);
    setClearSearch(false);
    setIsSearchBtnClick(false);
  };

  const searchOnClick = async (type) => {
    try {
      setLoading(true);
       const requestBody = {
        status: true,
        pageNumber:0,
        pageSize: rowsPerPage ?? 10,
        search: searchValue && searchValue.trim(),
      };
      
      setIsSearchBtnClick(true);
      setsearchValue_(searchValue);
      await onSearchUser(BASE_URL, requestBody, searchValue && searchValue.trim());
      setSelected([]);
      setDisbaleUpdateButton(true)
      setPage(0);
      setMaxPage(0)
    } catch (err) {
     
      showNotification("Error", err.message ?? "Failed to fetch user details");
    } finally {
      setLoading(false);
    }
    setNameSearch(searchValue && searchValue.trim());
  };

  const handlUserListItem = (e, itemAction) => {
    let row = slcRow;
    setAnchorEl(null);
    if (itemAction === "editUserDetails") {
      handleClickOpen(row);
    } else if (itemAction === "editUserRights") {
      handleClickUserRightsOpen(row);
    } else {
      console("Error in users spare extra listing menu");
    }
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - userRecords.length) : 0;

  const handleActiveChange = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
    if (newSelected.length !== 0) {
      setDisbaleUpdateButton(false);
    } else {
      setDisbaleUpdateButton(true);
    }
    const newSearchedRow = userRecords.map((currentRow) => {
      if (currentRow.userId === id) {
        return {
          ...currentRow,
          active: event.target.checked,
        };
      }
      return currentRow;
    });
    setUserRecords(newSearchedRow);
  };

  const onChangeStatusSubmit = async () => {
    const resultRecords = [];
    selected.forEach((itemId) => {
      const tempItem = userRecords.find((record) => record.userId === itemId);
      if (tempItem) {
        resultRecords.push({
          modifiedBy: tempItem.modifiedBy,
          status: tempItem.active,
          userId: tempItem.userId,
        });
      }
    });
    try {
      const res = await UserChangeStatusService(resultRecords);
      if (res.statusCode === 6) {
        // await fetchUsersDetails("firstName", true, page);
        setSelected([]);
        showNotification("Success", res.message, "success");
        setDisbaleUpdateButton(true);
      } else {
        showNotification("Error", res.message, "error");
      }
    } catch (e) {
    } finally {
    }
  };

  const onSelectDepartment = (deptId) => {
    const newRoleList = roleList && roleList.filter((r) => r.department['departmentId'] === deptId);
    setRoles(newRoleList);
  };

  const handleClick = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSlcRow(row);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    const paginationData = {
      pageNumber: 0,
      pageSize: rowsPerPage,
    };
    setSelected([]);
    setDisbaleUpdateButton(true)
    fetchUsersDetails(property, isAsc, searchValue_&& searchValue_.trim(),paginationData);
    setSortValue(isAsc ? "DESC" : "ASC");
    setPage(0);
    setMaxPage(0);
    //setSearchValue("");
  };

  const handleLockUnlockUser = async (email) => {
    try {
      const obj = {
        username: email,
      };
      const response = await UnlockUserService(obj);
      if (response.statusCode === 6) {
        setUserLockUnlockDialog(false);
        showNotification("Success", response.message, "success");
        setPage(0);
        setMaxPage(0);
        await fetchUsersDetails("firstName", true);
      } else {
        showNotification("Error", response.message ?? "Error");
      }
    } catch (err) {
      showNotification("Error", err.message ?? "Error");
    }
  };
  return (
    <>
      <Container maxWidth="lg" sx={{ mt: 7 }}>
        <Grid container spacing={2} sx={{ px: 0, mb: 2 }} display="flex">
          <Grid item xs={3} md={3}>
            <Typography
              align="left"
              sx={{ mr: "auto", color: "#003f93" }}
              variant="h6"
            >
              User Listing ( {totalElements ? totalElements : 0} )
            </Typography>
          </Grid>
          <Grid item xs={9} md={9}>
            <Typography align="right">
              <div className="searchContainer">
                <input
                  type="text"
                  placeholder="By Name and Email"
                  onChange={searchText}
                  className="searchInput2"
                  value={searchValue}
                />
              <IconButton disabled={searchValue === ""} className={searchValue === "" ? 'searchIcon':'filPrimaryColor searchIcon'}>
                <SearchIcon
                  //className="searchIcon"
                  onClick={() => searchOnClick("firstName")}
                />
                </IconButton>
                {clearSearch && (
                  <ClearIcon
                    sx={{ fontSize: "22px", color: "red" }}
                    className="searchClear"
                    onClick={onclickClear}
                  />
                )}
              </div>
              <Tooltip title="Add User">
                <Button
                  variant="contained"
                  onClick={() => {
                    handleClickOpenOnAdd();
                  }}
                  sx={{ ml: 1 }}
                  className="button-primary-alt-contained"
                  startIcon={<Add />}
                >
                  Add User
                </Button>
              </Tooltip>
              <Tooltip title="Update User Status">
                <Button
                  variant="contained"
                  sx={{ ml: 1, mr: 1 }}
                  className="button-primary-alt-contained"
                  onClick={onChangeStatusSubmit}
                  disabled={disableUpdateButton}
                >
                  Status Update
                  {selected.length !== 0 &&
                    ` (${Object.keys(selected).length})`}
                </Button>
              </Tooltip>
            </Typography>
          </Grid>
          <Grid item xs={12} mb={4} sx={{ mt: 1 }}>
            {/* {searchedRows && searchedRows.length > 0 ? ( */}
            <Paper sx={{ width: "100%", overflow: "hidden" }}>
              <TableContainer sx={{ maxHeight: 720 }}>
                <Table
                  stickyHeader
                  aria-label="sticky table"
                  aria-labelledby="tableTitle"
                  size="small"
                >
                  <EnhancedTableHead
                    numSelected={selected.length}
                    rowCount={searchedRows.length}
                    onRequestSort={handleRequestSort}
                    order={order}
                    orderBy={orderBy}
                  />
                  {searchedRows && searchedRows?.length > 0 ? (
                    <TableBody sx={{ mt: 2 }}>
                      {/* {stableSort(searchedRows, getComparator(order, orderBy)) */}
                      {searchedRows
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row, index) => {
                          const isItemSelected = isSelected(row.userId);
                          const labelId = `enhanced-table-checkbox-${index}`;
                          return (
                            <TableRow
                              hover
                              role="checkbox"
                              aria-checked={isItemSelected}
                              tabIndex={-1}
                              selected={isItemSelected}
                              key={row.userId}
                            >
                              <TableCell size="small" key={"employeeId"}>
                                {row["employeeId"] ?? "-"}
                              </TableCell>
                              <TableCell size="small" key={"firstName"}>
                                {`${row["firstName"]} ${row["lastName"]}` ??
                                  "-"}
                              </TableCell>
                              <TableCell size="small" key={"email"}>
                                {row["email"] ?? "-"}
                              </TableCell>
                              <TableCell size="small" key={"deptName"}>
                                {row["deptName"] ?? "-"}
                              </TableCell>
                              <TableCell size="small" key={"roleName"}>
                                {row["roleName"] ?? "-"}
                              </TableCell>
                              <TableCell align="center">
                                {" "}
                                <Checkbox
                                  color="primary"
                                  checked={(isItemSelected, row.active)}
                                  classes={{root: 'custom-checkbox-root'}}
                                  onClick={(event) =>
                                    handleActiveChange(event, row.userId)
                                  }
                                  disabled={
                                    loginUserInfo.userType === "Domain Admin" && (row["userTypeName"] === "Main Admin" ||
                                      loginUserInfo.department !== row.deptName)
                                  }
                                  inputProps={{
                                    "aria-labelledby": labelId,
                                  }}
                                />
                              </TableCell>
                              {(loginUserInfo.userType === "Main Admin" && !row.email?.endsWith("@ril.com") || (((loginUserInfo.userType === "Domain Admin" && row["userTypeName"] !== "Main Admin") && loginUserInfo.department == row.deptName) && !row.email?.endsWith("@ril.com"))) ? (
                                <TableCell>
                                  {row.isLocked === "N" ? (
                                    <Tooltip title="Lock User">
                                      <IconButton sx={{ color: "#013480" }}  classes={{root: 'custom-checkbox-root'}}>
                                        <LockOpenIcon
                                          onClick={() => handleLockUnlockDialogOpen(row.email,`${row["firstName"]} ${row["lastName"]}`,row.isLocked )}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  ) : (
                                    <Tooltip title="Unlock User">
                                      <IconButton sx={{ color: "#013480" }}  classes={{root: 'custom-checkbox-root'}}>
                                        <LockIcon
                                          onClick={() => handleLockUnlockDialogOpen(row.email,`${row["firstName"]} ${row["lastName"]}`,row.isLocked )}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                                </TableCell>
                              ) : (
                                <TableCell>
                                  <IconButton
                                  classes={{root: 'custom-checkbox-root'}}
                                    sx={{ color: "#013480" }}
                                    disabled
                                  >
                                    <LockOpenIcon />
                                  </IconButton>
                                </TableCell>
                              )}
                              <TableCell>
                                <MoreVertIcon
                                  color={
                                    loginUserInfo.userType === "Domain Admin" && (row["userTypeName"] === "Main Admin" ||
                                      loginUserInfo.department !== row.deptName)
                                      ? "disabled"
                                      : "primary"
                                  }
                                  onClick={
                                    loginUserInfo.userType === "Domain Admin" && (row["userTypeName"] === "Main Admin" ||
                                      loginUserInfo.department !== row.deptName)
                                      ? null
                                      : (event) => {
                                        handleClick(event, row);
                                      }
                                  }
                                  fontSize="small"
                                />
                                <Menu
                                  id="basic-menu"
                                  anchorEl={anchorEl}
                                  open={open}
                                  onClose={handleCloseMenu}
                                  MenuListProps={{
                                    "aria-labelledby": "basic-button",
                                  }}
                                >
                                  <MenuItem
                                    onClick={(e) => {
                                      handlUserListItem(e, "editUserDetails");
                                    }}
                                  // disabled={
                                  //   loginUserInfo.userType ===
                                  //     "Domain Admin" &&
                                  //   loginUserInfo.department !== row.deptName
                                  // }
                                  >
                                    <EditIcon
                                      fontSize="medium"
                                      color="disabled"
                                      sx={{ mr: 1 }}
                                    />
                                    Edit User Details
                                  </MenuItem>
                                  <MenuItem
                                    onClick={(e) => {
                                      handlUserListItem(e, "editUserRights");
                                    }}
                                  >
                                    <EditIcon
                                      fontSize="medium"
                                      color="disabled"
                                      sx={{ mr: 1 }}
                                    />
                                    Edit Access Rights
                                  </MenuItem>
                                </Menu>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      {emptyRows > 0 && (
                        <TableRow
                          style={{
                            height: 33 * emptyRows,
                          }}
                        >
                          <TableCell colSpan={7} />
                        </TableRow>
                      )}
                    </TableBody>
                  ) : (
                    <TableBody>
                      <TableRow>
                        {noRecord ? (
                          <TableCell colSpan={7}>
                            <RecordNotFound />
                          </TableCell>
                        ) : (
                          <TableCell colSpan={7} />
                        )}
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
              {searchedRows && searchedRows.length > 0 ? (
                <TablePagination
                  className="newPagination"
                  sx={{ margin: "auto" }}
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  component="div"
                  count={totalElements}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              ) : null}
            </Paper>
            <AddUser
              openDialog={openAddUserDialog}
              handleClose={handleClose}
              fetchUsersDetails={fetchUsersDetails}
              userRecords={userRecords}
              register={register}
              handleSubmit={handleSubmit}
              errors={errors}
              onAddEditUserSubmit={onAddEditUserSubmit}
              isEditMode={isEditMode}
              formData={formData}
              departmentList={departmentList}
              roleList={roles}
              userTypeList={userTypeList}
              setValue={setValue}
              setDeptName={setDeptName}
              setRoleName={setRoleName}
              setUserTypeName={setUserTypeName}
              isUpdateButton={isUpdateButton}
              setIsUpdateButton={setIsUpdateButton}
              userRolesAccessDetails={userRolesAccessDetails}
              setLoading={setLoading}
              showNotification={showNotification}
              userId={userId}
              onSelectDepartment={onSelectDepartment}
              disableUserType={disableUserType}
              loginUserInfo={loginUserInfo}
            />
            <UserEditRolesAccessPage
              openDialog={openEditUserRightsDialog}
              userRolesAccessDetails={userRolesAccessDetails}
              setLoading={setLoading}
              showNotification={showNotification}
              userId={userId}
              handleClose={handleCloseUserRightsDialog}
              loginUserInfo={loginUserInfo}
            />
          </Grid>
        </Grid>
      </Container>
      <Dialog
        open={lockUnlockUserDialog}
        onClose={handleLockUnlockDialogClose}
        maxWidth="xs"
      >
        <DialogTitle
          //color="error"
          sx={{
            backgroundColor: "#003f93",
            color: "#ffffff",
            fontSize: "16px",
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <div>{isLocked === "N" ? 'lock': 'unlock'} User </div>
            <GridCloseIcon
              className="pageHeader"
              onClick={handleLockUnlockDialogClose}
              style={{ cursor: "pointer", color: "white" }}
            />
          </Box>
        </DialogTitle>
        <Divider />
        <Grid container className="bg-white">
          <Grid item xs={12} md={12}>
            <Grid item xs={12} md={12} sx={{ p: 3 }}>
              <Box>Are you sure you want to <b>{isLocked === "N" ? 'lock': 'unlock'}</b> {userName} ?</Box>
            </Grid>
            <Divider />
            <React.Fragment>
              <Box
                sx={{ display: "flex", flexDirection: "row", p: 1.5, pl: 23 }}
              >
                <Button
                  variant="outlined"
                  onClick={handleLockUnlockDialogClose}
                  sx={{ mr: 1 }}
                >
                  Cancel
                </Button>
                <Button 
                  type="submit"
                  onClick={() => handleLockUnlockUser(userEmail)}
                  sx={{ mr: 1 }}
                  variant="contained"
                  className="button-primary-alt-contained"
                >
                  Yes
                </Button>
                <Box sx={{ flex: "1 1 auto" }} />
              </Box>
            </React.Fragment>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
}

function EnhancedTableHead({ onRequestSort, order, orderBy }) {
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableHead>
      <TableRow key={"1"}>
        {USER_DETAILS_LISTING_COLUMNS.map((headCell) => (
          <TableCell
            size="small"
            variant="head"
            className="tableHeader"
            sx={{ pt: 1.5, pb: 1.5 }}
            key={headCell.userId}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            style={{
              minWidth: headCell.minWidth,
              fontWeight: "bold",
              color: "#003A6B",
            }}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={
                headCell.id === "action" ||
                  headCell.id === "active" ||
                  headCell.id === "lock"
                  ? false
                  : orderBy === headCell.id
              }
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
              hideSortIcon={
                (headCell.id === "action" ||
                  headCell.id === "active" ||
                  headCell.id === "lock") &&
                true
              }
              disabled={
                (headCell.id === "action" || headCell.id === "active") && true
              }
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
